import { Component, OnInit,  AfterViewInit } from '@angular/core';

import { FormComponentLookup, EntryConfigInterface } from '@ptl/forms';
import { FormControl, FormGroup } from '@angular/forms';
import { ReducerUtilityService as ReducerUtilityService2} from 'src/app/shared/utility-services/reducer-utility.service';
import moment from 'moment';
import { ZipCountyStateStructure } from 'src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface';
import { FormEntryComponentClass } from '@ptl/forms';

@FormComponentLookup('custom-zip-code-label')
@Component({
    selector: 'app-custom-zip-code-label',
    templateUrl: './custom-zip-code-label.component.html',
    styleUrls: ['./custom-zip-code-label.component.scss'],
    standalone: false
})
export class CustomZipCodeLabelComponent extends FormEntryComponentClass {

  radioFormGroups: {};
  zipcountyState: ZipCountyStateStructure;
  constructor(
    protected reducerUtilityService2: ReducerUtilityService2
  ) {
    super();
  }

  ngOnInit() {
    this.zipcountyState = this.reducerUtilityService2.getState(
      'ZipCounty'
    );

  }


}
